import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: 'Do I need special equipment?',
    a: 'No. We actually recommend "No-Chop" methods to save your hands and wrists.'
  }, {
    q: 'Is the food expensive?',
    a: 'No. We focus on common, nutrient-dense ingredients found in any standard US grocery store.'
  }, {
    q: "I'm vegetarian/gluten-free. Can I use this?",
    a: 'Yes. The "Micro-Prep" principles work across all dietary preferences.'
  }, {
    q: 'Is this a physical book?',
    a: 'This is a digital PDF eBook for instant access on your phone, tablet, or computer.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-6 px-4 md:px-8" data-id="element-26">
      <div className="max-w-2xl mx-auto" data-id="element-27">
        <FadeIn data-id="element-28">
          <h2 className="text-xl md:text-2xl font-bold text-forest mb-3 text-center" data-id="element-29">
            Frequently Asked Questions
          </h2>
        </FadeIn>

        <div className="space-y-2" data-id="element-30">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.08 * index} data-id="element-31">
              <div className="border border-gray-200 rounded-lg overflow-hidden bg-cream-dark" data-id="element-32">
                <button className="w-full px-4 py-3 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-33">
                  <span className="font-bold text-sm md:text-base text-forest pr-3" data-id="element-34">
                    {faq.q}
                  </span>
                  {openIndex === index ? <ChevronUp className="w-4 h-4 text-forest flex-shrink-0" data-id="element-35" /> : <ChevronDown className="w-4 h-4 text-forest flex-shrink-0" data-id="element-36" />}
                </button>

                {openIndex === index && <div className="px-4 pb-3 text-sm text-charcoal" data-id="element-37">
                    <p data-id="element-38">{faq.a}</p>
                  </div>}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}